import {
  USER_ID,
  DISPLAYNAME,
  EMAIL,
  PROFILE_URL,
  ACTIVATE,
  UNIQUE_ID,
  ALLOW_CHANGE_EMAIL,
  PROVIDERS,
  RISK_PROFILE,
  PROFILE_IMAGE,
  NEW_EMAIL,
  TEL
} from './constant'
import { GetterTree } from 'vuex'
import { ProfileState } from './types'

export const getters: GetterTree<ProfileState, any> = {
  [USER_ID]: state => state.userID,
  [DISPLAYNAME]: state => state.displayName,
  [EMAIL]: state => state.email,
  [PROFILE_URL]: state => state.profileURL,
  [ACTIVATE]: state => state.activate,
  [UNIQUE_ID]: state => state.uniqueID,
  [ALLOW_CHANGE_EMAIL]: state => state.allowChangeEmail,
  [PROVIDERS]: state => state.providers,
  [RISK_PROFILE]: state => state.riskProfile,
  [TEL]: state => state.tel,
  [PROFILE_IMAGE]: state => state.profileURL,
  [NEW_EMAIL]: state => state.changingEmail
}
